var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.422241 6.34324C0.422241 3.02758 3.16185 0.330078 6.52926 0.330078C9.89666 0.330078 12.6363 3.02758 12.6363 6.34324C12.6363 9.14004 10.6871 11.497 8.05601 12.1662V14.6113C8.05601 15.4416 7.37248 16.1146 6.52926 16.1146C5.68603 16.1146 5.0025 15.4416 5.0025 14.6113L5.0025 10.8531C5.0025 10.0228 5.68603 9.34982 6.52926 9.34982C8.21296 9.34982 9.58276 8.00107 9.58276 6.34324C9.58276 4.68541 8.21296 3.33666 6.52926 3.33666C4.84555 3.33666 3.47575 4.68541 3.47575 6.34324C3.47575 7.17351 2.79222 7.84653 1.94899 7.84653C1.10577 7.84653 0.422241 7.17351 0.422241 6.34324ZM8.43785 19.121C8.43785 20.1588 7.58341 21.0001 6.5294 21.0001C5.4754 21.0001 4.62096 20.1588 4.62096 19.121C4.62096 18.0831 5.4754 17.2418 6.5294 17.2418C7.58341 17.2418 8.43785 18.0831 8.43785 19.121Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.0a94864938d741ca7fdc2e367d5a86a5.svg";
export { ForwardRef as ReactComponent };